<template>
  <section class="relative h-full bg-gray-100">
      <div class="flex items-center justify-center h-auto px-2 no-underline bg-gradient-blue lg:px-0">
        <p
          class="py-4 text-sm font-bold text-center text-white lg:text-normal xl:text-normal"
        >{{ $t('messages.general.band') }}</p>
      </div>
    <div class="flex items-center justify-center h-full min-h-screen" v-if="loading">
      <img src="/storage/image/heart.png" alt="Heart JW" class="w-16" />
    </div>
    <div class="relative w-full" v-else>
      <agile
        class="w-full h-full absolute top-0 left-0"
        :infinite="true"
        :autoplay="true"
        :autoplay-speed="14000"
        :speed="3000"
        :nav-buttons="false"
        :timing="`linear`"
        fade
      >
        <div
          v-for="(slide, index) in profileHeroPhotos"
          :key="index"
          :style="{diplay: 'flex', 'background-image': 'url(' + slide + ')'}"
          class="slide slide-one bg-center bg-no-repeat bg-cover items-end h-full">
        </div>
      </agile>

      <div class="container relative flex flex-col items-center justify-center pb-0 mx-auto lg:flex-row lg:px-12 xl:pl-16">
        <div class="text-white flex flex-col w-full p-4 mt-10 md:flex-row md:mt-0 z-10 lg:items-center mb--4 lg:mb--24">
          <div class="relative p-0 md:pb-8 mx-auto text-center lg:p-4 lg:mx-0">
            <div class="absolute top-0 right-0 z-10 m-6">
              <subscription-type v-bind:user="user" ></subscription-type>
            </div>
            <img
              v-if="(user) ? user.pictures.length > 0: null"
              class="object-cover w-56 h-56 shadow-lg border-2 border-white rounded-lg"
              :src="coverUrl"
            />
            <img
              v-else
              class="object-cover w-56 h-56 shadow-lg border-2 border-white rounded-lg"
              src="/storage/image/placeholder-user.jpg"
              alt
            />
            <div class="py-2">
              <router-link
                class="z-20 font-semibold text-xs text-white lg:text-gray-800 hover:text-jblue-secondary lg:font-shadow-xs"
                to="/my-profile"
              > <i class="icon-eye lg:text-jblue-secondary pr-1 text-xs"></i> {{ $t('messages.general.see_my_profile') }}</router-link>
            </div>
          </div>

          <div class="p-0 md:p-6 lg:pb-8 lg:pl-2" v-if="(user) ? user.profile: null">
            <h1
              class="font-bold text-white text-shadow text-2xl text-center md:text-left">
              {{ user.username }}
            </h1>
            <p
              class="font-semibold text-white text-shadow text-center md:text-left text-base"
              v-if="user.profile.country"
            >{{ user.profile.country.name[locale] }}, {{ user.profile.city }}</p>
            <div class="flex items-center justify-center md:justify-start">
              <p
                class="text-white text-center text-base md:text-left text-shadow"
              >"<isRevisionPending :revision="user.revision" :value="user.profile.message_profile"></IsRevisionPending>"</p>
            </div>
            <div class="py-4 flex items-center flex-wrap justify-center md:justify-start f-full">
              <div class="pr-3 md:pl-0 lg:pl-0 lg:pl-0 h-full flex flex-row justify-between items-center">
                <div class="rounded-full w-6 h-6 flex justify-center items-center" :class="[`bg-j${user.profile.gender === 'female' ? 'pink' : 'blue'}-primary`]">
                  <i :class="[`icon-${user.profile.gender === 'female' ? 'woman' : 'man'}`, 'text-white', 'p-2', 'text-shadow']"></i>
                </div>
                <p
                  class="pl-2 text-xs text-white  text-shadow font-bold"
                >{{ (user.profile.gender === 'female') ? $t('messages.general.woman') : $t('messages.general.man') }}</p>
              </div>
              <div class="border-r border-white h-6 w-px shadow-lg"></div>

              <div class="px-3">
                <p
                  class="pr-2 text-xs text-white text-shadow font-bold"
                >{{ age(user.profile.birthday) }} {{ $t('messages.general.years') }}</p>
              </div>
              <div class="border-r border-white h-6 w-px shadow-lg"></div>

              <div class="px-3">
                <template v-if="user.profile.phone_validate === 0">
                  <div class="flex justify-center">
                    <router-link
                      class="px-2 py-1 text-xs text-white no-underline bg-green-500 border border-transparent rounded hover:bg-white hover:text-green-500 hover:border-green-500 shadow-lg flex items-center"
                      :to="{name: 'verifyPhone', params: { lang: locale, phone: user.profile.phone_mobile}}"
                    > <i class="flex items-center justify-center mr-4 text-xl icon-celular"></i>{{ $t('messages.general.verified_now') }}</router-link>
                  </div>
                </template>
                <template v-else-if="user.profile.phone_validate === 1">
                  <p class="text-xs flex justify-center text-white tracking-wide lg:justify-start text-shadow font-bold items-center">
                    <i class="flex items-center mr-4 text-2xl text-green-500 icon-celular"></i>
                    {{ $t('messages.general.mobile_verified') }}
                  </p>
                </template>
              </div>
              <div class="border-r border-transparent lg:border-white h-6 w-px shadow-lg"></div>

              <div class="px-3 pr-0 order-first w-full pb-3 lg:pb-0 lg:order-none lg:w-auto flex justify-center md:justify-start md:pl-0 lg:pl-3 lg:block">
                <p
                  class="text-white font-bold text-xs text-center md:text-left text-shadow"
                >
                  <span class="inline-block w-3 h-3 mr-2 bg-green-500 rounded-full"></span>
                  {{ `${$t('messages.general.connection')}: ${$t('messages.general.now')}` }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="bg-gray-200 shadow-lg w-full relative py-2">
        <div class="container lg:pl-12 xl:pl-16 mx-auto flex flex-row justify-between h-full items-center">
          <div class="flex-1 flex">
            <div class="w-0 lg:w-56 lg:p-4"></div>
            <div class="px-6 lg:px-10 flex flex-wrap items-center justify-around md:justify-start lg:justify-start h-full">
              <router-link to="/visits" class="flex mx-4 my-2 lg:my-1 text-xs justify-start items-center w-1/3 md:w-auto font-semibold text-gray-800 z-20">
                <div class="bg-gray-300 w-10 h-10 rounded-full flex justify-center items-center mr-2">
                  <i class="icon-greeting text-xl text-jblue-primary"></i>
                </div>
                {{ $t(`messages.general.visits_to_your_profile`) }}
              </router-link>
              <router-link to="/favorites" class="flex mx-4 my-2 lg:my-1 text-xs justify-start items-center w-1/3 md:w-auto font-semibold text-gray-800 z-20">
                <div class="bg-gray-300 w-10 h-10 rounded-full flex justify-center items-center mr-2">
                  <i class="icon-fav text-xl text-jblue-primary"></i>
                </div>
                {{ $t(`messages.general.favorites`) }}
                <span v-if="favorites > 0" class="flex items-center justify-center w-5 h-5 ml-2 text-xs font-medium text-white bg-blue-600 rounded-full">{{ favorites }}</span>
              </router-link>
              <router-link to="/reciprocal-favorites" class="flex mx-4 my-2 lg:my-1 text-xs justify-start items-center w-1/3 md:w-auto font-semibold text-gray-800 z-20">
                <div class="bg-gray-300 w-10 h-10 rounded-full flex justify-center items-center mr-2">
                  <i class="icon-compatability text-xl text-jblue-primary"></i>
                </div>
                {{ $t(`messages.general.reciprocal_favorites`) }}
              </router-link>
              <router-link to="/invitations" class="flex mx-4 my-2 lg:my-1 text-xs justify-start items-center w-1/3 md:w-auto font-semibold text-gray-800 z-20">
                <div class="bg-gray-300 w-10 h-10 rounded-full flex justify-center items-center mr-2">
                  <i class="icon-envelope text-xl text-jblue-primary"></i>
                </div>
                {{ $t(`messages.general.invitations`) }}
                <span v-if="invitations > 0" class="flex items-center justify-center w-5 h-5 ml-2 text-xs font-medium text-white bg-blue-600 rounded-full">{{ invitations }}</span>
              </router-link>
              <div to="#" @click="openChat"  class="flex mx-4 my-2 lg:my-1 text-xs justify-start items-center w-1/3 md:w-auto font-semibold text-gray-800 z-20 cursor-pointer">
                <div class="bg-gray-300 w-10 h-10 rounded-full flex justify-center items-center mr-2">
                  <i class="icon-message text-xl text-jblue-primary"></i>
                </div>
                {{ $t('messages.general.messages') }}
              </div>
            </div>
          </div>
          <div class="hidden md:flex z-99">
            <div class="flex flex-col items-center pr-2">
              <p class="font-semibold text-gray-800 text-xs">{{ $t('messages.general.download_app_title')}}</p>
              <a href="https://play.google.com/store/apps/details?id=com.jwperfectmatch.android" target="_blank" rel="nofollow">
                <img alt="jehovah's witnesses dating site android app" src="/storage/image/google.png" class="w-24 h-8" />
              </a>
            </div>
            <div class="flex flex-col items-center pl-2 border-l border-gray-500">
              <p class="font-semibold text-gray-800 text-xs">{{ $t('messages.general.coming_app_title')}}</p>
              <a href="/" target="_blank" rel="nofollow">
                <img alt="jehovah's witnesses dating site ios" src="/storage/image/apple.png" class="w-24 h-8" />
              </a>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>
<script>
import Spinner from "@/components/Spinner";
import SubscriptionType from '@/components/SubscriptionType';
import IsRevisionPending from '@/components/isRevisionPending';
import moment from 'moment';
import { mapActions, mapState } from "vuex";
import dayjs from "dayjs";

export default {
  name: "CardProfile",
  props: ["name", "description"],
  data() {
    return {
      loading: true,
      profileHeroPhotos: [],
      favorites: 0,
      invitations: 0
    };
  },
  components: {
    Spinner,
    SubscriptionType,
    IsRevisionPending
  },
  computed: {
    ...mapState("auth", ["user", "updateChatAlert"]),
    ...mapState("profiles", ["moreprofiles"]),
    ...mapState("locale", ["locale"]),
    coverUrl() {
      const picture = this.user.pictures.filter(
        photo => photo.status === "approved" && photo.cover === 1
      );

      if (picture.length > 0) {
        return picture[0].url;
      }
      return "/storage/image/placeholder-user.jpg";
    },
    coverFriends() {
      const picture = this.moreprofiles.filter(
        photo => photo.status === "approved" && photo.cover === 1
      );
      if (picture.length > 0) {
        return picture[0].url;
      }
      return "/storage/image/placeholder-user.jpg";
    }
  },
  async created() {
    await this.moreFriends();
  },
  async mounted() {
    await this.getUser();

    this.profileHeroPhotos = _
      .chain(_.range(1, 10))
      .map(photo => `/storage/profile_slider/${ photo }.jpg`)
      .value();


      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.profileHeroPhotos = _.chain(_.range(1, 6)).map(photo => `/storage/profile_slider_mobile/${ photo }.png`).value();
      }

    this.countUserNotifications();
  },
  updated() {
    this.countUserNotifications();
  },
  methods: {
    ...mapActions("auth", ["fetchUser"]),
    ...mapActions("profiles", ["moreFriends"]),
    countUserNotifications() {
      const countNotifications = types => this.user.notifications.filter(noti => types.includes(noti.type)).length;

      this.favorites = countNotifications(['favorite']);
      this.invitations = countNotifications(['subscription', 'greeting']);
    },
    async getUser() {
      this.loading = true;
      try {
        await this.fetchUser();
      } finally {
        this.loading = false;
      }
    },
    age(date) {
      return Math.floor((new Date() - new Date(date).getTime()) / 3.15576e10);
    },
    format(date) {
      if (date) {
        return dayjs(date).format("dddd h:m:s A");
      }
      return this.$t("messages.general.no_available");
    },
    showChatPolicies() {
      const today = moment();
      const last_display = moment.unix(this.user.profile.chat_alert);
      const diff = today.diff(last_display, 'days', true);

      return !last_display ? true : diff >= 60;
    },
    async openChat() {
      if (this.user.profile.state_chat === 0) {
        this.isOpen = true;
        await this.updateChatAlert();
      } else {
        this.isOpen = this.showChatPolicies();

        this.$router.push({
          name: "chat",
          params: {
            random: Date.now(),
            lang: this.locale
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .bg-gradient-blue {
    background: linear-gradient(90deg, #1C4C91 0%, #3A91F9 100%);
  }

  .font-shadow-xs {
    text-shadow: 1px 2px 3px rgba(0, 0 ,0 , 0.8);
  }

  .lg\:font-shadow-xs {
    @media only screen and (max-width: 1024px) {
      text-shadow: 1px 2px 3px rgba(0, 0 ,0 , 0.8);
    }
  }
  .agile {
    position: absolute!important;
  }
  .slide-one {
    background-image: url("/storage/profile_slider/1.jpg");
    display: flex !important;
  }
  .slide-two {
    background-image: url("/storage/profile_slider/2.jpg");
    display: flex !important;
  }
  .slide-three {
    background-image: url("/storage/profile_slider/3.jpg");
    display: flex !important;
  }
  .slide-four {
    background-image: url("/storage/profile_slider/4.jpg");
    display: flex !important;
  }

  .mb--4 {
    margin-bottom: -0.5rem;
  }

  .lg\:mb--24 {
    @media only screen and (min-width: 1024px) {
      margin-bottom: -5.5rem;
    }
  }

.text-shadow {
  text-shadow: 1px 2px 2px #000000;
}
</style>
